var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3WidgetView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.43 47a6 6 0 01-5.67 6H20.57a6 6 0 010-12h34.19a6 6 0 015.67 6zM20.57 35h34.19a6 6 0 100-12H20.57a6 6 0 100 12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Widget_view.24e56518.svg";
export { SvgJ3WidgetView as ReactComponent };